import createIcon from '../../createIcon';

/**
 * @component @name PanoramaWideAngleSelect
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNEM5LjI3IDQgNi43OCA0LjI0IDQuMDUgNC43MkwzLjEyIDQuODhMMi44NyA1Ljc4QzIuMjkgNy44NSAyIDkuOTMgMiAxMkMyIDE0LjA3IDIuMjkgMTYuMTUgMi44NyAxOC4yMkwzLjEyIDE5LjExTDQuMDUgMTkuMjdDNi43OCAxOS43NiA5LjI3IDIwIDEyIDIwQzE0LjczIDIwIDE3LjIyIDE5Ljc2IDE5Ljk1IDE5LjI4TDIwLjg4IDE5LjEyTDIxLjEzIDE4LjIzQzIxLjcxIDE2LjE1IDIyIDE0LjA3IDIyIDEyQzIyIDkuOTMgMjEuNzEgNy44NSAyMS4xMyA1Ljc4TDIwLjg4IDQuODlMMTkuOTUgNC43M0MxNy4yMiA0LjI0IDE0LjczIDQgMTIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PanoramaWideAngleSelect = createIcon('PanoramaWideAngleSelect', [
  [
    'path',
    {
      d: 'M12 4C9.27 4 6.78 4.24 4.05 4.72L3.12 4.88L2.87 5.78C2.29 7.85 2 9.93 2 12C2 14.07 2.29 16.15 2.87 18.22L3.12 19.11L4.05 19.27C6.78 19.76 9.27 20 12 20C14.73 20 17.22 19.76 19.95 19.28L20.88 19.12L21.13 18.23C21.71 16.15 22 14.07 22 12C22 9.93 21.71 7.85 21.13 5.78L20.88 4.89L19.95 4.73C17.22 4.24 14.73 4 12 4Z',
      key: '1yrq1p',
    },
  ],
]);

export default PanoramaWideAngleSelect;
